// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/adf-tracking-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/adf-tracking-procedures/adf-tracking-procedures.js';

mount([g0]);
